import { render, staticRenderFns } from "./HomeSbSwiper.vue?vue&type=template&id=2cf60cb2&"
import script from "./HomeSbSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSbSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports